export default __webpack_public_path__ + "static/media/data-mining.af3ebea3.svg";